// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chart-pie.svg. Do not edit.

import { glyph } from '@gto/icons/glyphs/outline/chart-pie'

import { Icon, type IconComponentProps } from '../icon'

export const ChartPieIcon = (props: IconComponentProps) => (
  <Icon
    glyph={glyph}
    {...props}
  />
)
